module.exports = __webpack_public_path__ + "assets/img/2004.16c1522a.svg";